module.exports = __webpack_public_path__ + "static/media/replay_rate_title_bg.b14cdcb2.png";